/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Pipe, PipeTransform } from '@angular/core';
import { ShowIfRequirements } from '../../../../../models/SideNavItem';
import { MainFilterItem } from '../../app-details/MainFilterItem';
import { User } from '../../../../../models/User';

@Pipe({
  name: 'showIf'
})
export class ShowIfPipe implements PipeTransform {
  constructor(private userService: User) {}

  transform(
    data: any,
    showIfReq: ShowIfRequirements,
    os: string,
    mainFilterItems: Array<MainFilterItem>
  ): boolean {
    if (!showIfReq) return true;

    if (
      showIfReq.hasPermission &&
      !this.userService.hasPermission(showIfReq.hasPermission)
    ) {
      return false;
    }

    if (showIfReq.hasData) {
      if (
        showIfReq.hasData.notNA &&
        this.getData(data, showIfReq.hasData.notNA) === 'N/A'
      )
        return false;

      if (
        showIfReq.hasData.notNull &&
        !this.getData(data, showIfReq.hasData.notNull)
      )
        return false;

      if (showIfReq.hasData.notEmpty) {
        if (Array.isArray(showIfReq.hasData.notEmpty)) {
          let ret = false;
          showIfReq.hasData.notEmpty.forEach(item => {
            if (this.getData(data, item)?.length > 0) {
              ret = true;
            }
          });
          return ret;
        } else {
          const notEmptyData = this.getData(data, showIfReq.hasData.notEmpty);
          if (!notEmptyData || notEmptyData.length <= 0) {
            return false;
          }
        }
      }

      if (showIfReq.hasData.gtOne) {
        const gtOneData = this.getData(data, showIfReq.hasData.gtOne);
        if (!gtOneData || gtOneData <= 1) {
          return false;
        }
      }
    }

    if (showIfReq.isFilter) {
      if (showIfReq.isFilter.os) {
        if (os !== showIfReq.isFilter.os) {
          return false;
        }
      }
    }
    return true;
  }

  getData(data: any, path: string): any {
    const paths = path.split('/');
    paths.forEach(path => {
      if (data) {
        data = data[path];
      }
    });
    return data;
  }
}
